import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import "./assets/tailwind.css";

import { onMounted, computed } from "vue";
import { useRouter, useRoute } from "vue-router";

import { AuthService } from "./services/auth/AuthService";

import MyTopbar from "./components/organisms/MyTopbar.vue";
import MyFooter from "./components/organisms/MyFooter.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const showTopbar = computed(() => {
  return typeof route.name == "string" && !route.name.includes("auth");
});
const showbottombar = computed(() => {
  return typeof route.name == "string" && !route.name.includes("auth");
});

const authService = new AuthService();

async function checkSession() {
  if (route.name == "auth-forgot-password") {
    router.push({ name: "auth-forgot-password" });
    return;
  }
  if (route.name == "auth-forgot-password-return") {
    router.push({ name: "auth-forgot-password-return" });
    return;
  }
  /*const hasValidSession = await authService.hasValidUserSession();
      if (!hasValidSession) {
        console.log(route.name);
        console.log(route.name == "auth-forgot-password-return");

        //router.push({ name: "auth-login" });
      } else {
        router.push({ name: "MyStocks" });
      }*/
}

const scrollDown = () => {
  window.scrollTo(0, document.body.scrollHeight);
};

onMounted(() => {
  checkSession();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(showTopbar))
      ? (_openBlock(), _createBlock(MyTopbar, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, {
      class: _normalizeClass(["min-h-screen", {
      'm-6 mt-24 sm:mt-32 mb-10 sm:mx-10': _unref(showTopbar),
    }])
    }, null, 8, ["class"]),
    _createVNode(MyFooter),
    _createElementVNode("div", {
      class: "fixed flex flex-row md:text-lg items-center justify-center bottom-4 md:bottom-8 right-4 md:right-8 rounded-full h-10 md:h-16 w-10 md:w-16 bg-primary-green text-white p-2 md:p-4 drop-shadow-lg hover:scale-110 transition-all",
      onClick: _cache[0] || (_cache[0] = () => scrollDown())
    }, [
      _createVNode(_component_mdicon, {
        name: "help-circle-outline",
        size: "36"
      })
    ])
  ], 64))
}
}

})